export const socialKeys = {
  all: ["social"] as const,
  sessionPost: (socialPostId: string) => [...socialKeys.all, "sessionPost", socialPostId] as const,
  userExercisePost: (userId: string, exerciseId: string) =>
    [...socialKeys.all, "userExercisePost", userId, exerciseId] as const,
  comments: (socialPostId: string) => [...socialKeys.all, "comments", socialPostId] as const,
  reactions: (socialPostId: string) => [...socialKeys.all, "reactions", socialPostId] as const,
  commentReactions: (socialPostId: string, commentId: string) =>
    [...socialKeys.all, "commentReactions", socialPostId, commentId] as const,
  mentionableUsers: (socialPostId: string, filter: string) =>
    [...socialKeys.all, "mentionableUsers", socialPostId, filter] as const,
}
